import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks'
import { BoxWithLabel } from '../../../../../common/components/BoxWithLabel'
import { ReferralBaseInfo } from '../../types/patientReferrals.types'

interface ReferralDetailsStepProps {
  referralBaseInfo: ReferralBaseInfo
}
const ReferralDoctorDetails: React.FC<ReferralDetailsStepProps> = ({
  referralBaseInfo,
}) => {
  const { t } = useTranslation()

  return (
    <BoxWithLabel label={t('doctor:referralDetails.doctor')}>
      <Stack>
        <Typography variant="body2">
          {t('common:formattedNameFull', {
            title: referralBaseInfo.doctor.title,
            firstName: referralBaseInfo.doctor.firstName,
            lastName: referralBaseInfo.doctor.lastName,
          })}
        </Typography>

        <Typography variant="subtitle1">
          {referralBaseInfo.doctor.stampNumber}
        </Typography>
      </Stack>
    </BoxWithLabel>
  )
}

export { ReferralDoctorDetails }
